/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { commentControllerCreate } from '../fn/comment/comment-controller-create';
import { CommentControllerCreate$Params } from '../fn/comment/comment-controller-create';
import { commentControllerDelete } from '../fn/comment/comment-controller-delete';
import { CommentControllerDelete$Params } from '../fn/comment/comment-controller-delete';
import { commentControllerFindById } from '../fn/comment/comment-controller-find-by-id';
import { CommentControllerFindById$Params } from '../fn/comment/comment-controller-find-by-id';
import { commentControllerFindByPickId } from '../fn/comment/comment-controller-find-by-pick-id';
import { CommentControllerFindByPickId$Params } from '../fn/comment/comment-controller-find-by-pick-id';
import { commentControllerMy } from '../fn/comment/comment-controller-my';
import { CommentControllerMy$Params } from '../fn/comment/comment-controller-my';
import { commentControllerReport } from '../fn/comment/comment-controller-report';
import { CommentControllerReport$Params } from '../fn/comment/comment-controller-report';
import { commentControllerSearchCursor } from '../fn/comment/comment-controller-search-cursor';
import { CommentControllerSearchCursor$Params } from '../fn/comment/comment-controller-search-cursor';
import { commentControllerSearchOffset } from '../fn/comment/comment-controller-search-offset';
import { CommentControllerSearchOffset$Params } from '../fn/comment/comment-controller-search-offset';
import { commentControllerToggleBlocked } from '../fn/comment/comment-controller-toggle-blocked';
import { CommentControllerToggleBlocked$Params } from '../fn/comment/comment-controller-toggle-blocked';
import { commentControllerUpdate } from '../fn/comment/comment-controller-update';
import { CommentControllerUpdate$Params } from '../fn/comment/comment-controller-update';
import { CommentDto } from '../models/comment-dto';
import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class CommentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `commentControllerSearchOffset()` */
  static readonly CommentControllerSearchOffsetPath = '/api/comments/{id}/search/offset';

  /**
   * 댓글 오프셋 기반 조회.
   *
   * 댓글을 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerSearchOffset$Response(params: CommentControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return commentControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 댓글 오프셋 기반 조회.
   *
   * 댓글을 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerSearchOffset(params: CommentControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.commentControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `commentControllerMy()` */
  static readonly CommentControllerMyPath = '/api/comments/my';

  /**
   * 회원 작성 댓글 조회.
   *
   * 회원이 작성한 댓글을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentControllerMy()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerMy$Response(params?: CommentControllerMy$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CommentDto>>> {
    return commentControllerMy(this.http, this.rootUrl, params, context);
  }

  /**
   * 회원 작성 댓글 조회.
   *
   * 회원이 작성한 댓글을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentControllerMy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerMy(params?: CommentControllerMy$Params, context?: HttpContext): Observable<Array<CommentDto>> {
    return this.commentControllerMy$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CommentDto>>): Array<CommentDto> => r.body)
    );
  }

  /** Path part for operation `commentControllerFindById()` */
  static readonly CommentControllerFindByIdPath = '/api/comments/{id}';

  /**
   * 댓글 ID 기반 조회.
   *
   * 댓글을 ID 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerFindById$Response(params: CommentControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<CommentDto>> {
    return commentControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 댓글 ID 기반 조회.
   *
   * 댓글을 ID 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerFindById(params: CommentControllerFindById$Params, context?: HttpContext): Observable<CommentDto> {
    return this.commentControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CommentDto>): CommentDto => r.body)
    );
  }

  /** Path part for operation `commentControllerDelete()` */
  static readonly CommentControllerDeletePath = '/api/comments/{id}';

  /**
   * 댓글 삭제.
   *
   * 댓글을 삭제합니다
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerDelete$Response(params: CommentControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CommentDto>> {
    return commentControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 댓글 삭제.
   *
   * 댓글을 삭제합니다
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerDelete(params: CommentControllerDelete$Params, context?: HttpContext): Observable<CommentDto> {
    return this.commentControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CommentDto>): CommentDto => r.body)
    );
  }

  /** Path part for operation `commentControllerUpdate()` */
  static readonly CommentControllerUpdatePath = '/api/comments/{id}';

  /**
   * 댓글 수정.
   *
   * 댓글을 수정합니다
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commentControllerUpdate$Response(params: CommentControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<CommentDto>> {
    return commentControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 댓글 수정.
   *
   * 댓글을 수정합니다
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commentControllerUpdate(params: CommentControllerUpdate$Params, context?: HttpContext): Observable<CommentDto> {
    return this.commentControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CommentDto>): CommentDto => r.body)
    );
  }

  /** Path part for operation `commentControllerFindByPickId()` */
  static readonly CommentControllerFindByPickIdPath = '/api/comments/pick/{pickId}';

  /**
   * 픽 게시글 ID 기반 조회.
   *
   * 댓글을 게시글 ID 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentControllerFindByPickId()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerFindByPickId$Response(params: CommentControllerFindByPickId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CommentDto>>> {
    return commentControllerFindByPickId(this.http, this.rootUrl, params, context);
  }

  /**
   * 픽 게시글 ID 기반 조회.
   *
   * 댓글을 게시글 ID 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentControllerFindByPickId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerFindByPickId(params: CommentControllerFindByPickId$Params, context?: HttpContext): Observable<Array<CommentDto>> {
    return this.commentControllerFindByPickId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CommentDto>>): Array<CommentDto> => r.body)
    );
  }

  /** Path part for operation `commentControllerSearchCursor()` */
  static readonly CommentControllerSearchCursorPath = '/api/comments/search/cursor/pick/{pickId}';

  /**
   * 픽 ID 기반 커서 조회.
   *
   * 코멘트를 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerSearchCursor$Response(params: CommentControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return commentControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 픽 ID 기반 커서 조회.
   *
   * 코멘트를 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerSearchCursor(params: CommentControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.commentControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `commentControllerCreate()` */
  static readonly CommentControllerCreatePath = '/api/comments';

  /**
   * 댓글 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commentControllerCreate$Response(params: CommentControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CommentDto>> {
    return commentControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 댓글 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commentControllerCreate(params: CommentControllerCreate$Params, context?: HttpContext): Observable<CommentDto> {
    return this.commentControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CommentDto>): CommentDto => r.body)
    );
  }

  /** Path part for operation `commentControllerReport()` */
  static readonly CommentControllerReportPath = '/api/comments/{id}/report';

  /**
   * 댓글 신고.
   *
   * 댓글을 신고합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentControllerReport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commentControllerReport$Response(params: CommentControllerReport$Params, context?: HttpContext): Observable<StrictHttpResponse<CommentDto>> {
    return commentControllerReport(this.http, this.rootUrl, params, context);
  }

  /**
   * 댓글 신고.
   *
   * 댓글을 신고합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentControllerReport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commentControllerReport(params: CommentControllerReport$Params, context?: HttpContext): Observable<CommentDto> {
    return this.commentControllerReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<CommentDto>): CommentDto => r.body)
    );
  }

  /** Path part for operation `commentControllerToggleBlocked()` */
  static readonly CommentControllerToggleBlockedPath = '/api/comments/{id}/toggle-blocked';

  /**
   * 댓글 차단 ON/OFF.
   *
   * 댓글 차단 여부를 스위칭합니다. 차단 시, 댓글 및 해당 댓글의 대댓글은 게시글 데이터에 포함되지 않습니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentControllerToggleBlocked()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerToggleBlocked$Response(params: CommentControllerToggleBlocked$Params, context?: HttpContext): Observable<StrictHttpResponse<CommentDto>> {
    return commentControllerToggleBlocked(this.http, this.rootUrl, params, context);
  }

  /**
   * 댓글 차단 ON/OFF.
   *
   * 댓글 차단 여부를 스위칭합니다. 차단 시, 댓글 및 해당 댓글의 대댓글은 게시글 데이터에 포함되지 않습니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentControllerToggleBlocked$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerToggleBlocked(params: CommentControllerToggleBlocked$Params, context?: HttpContext): Observable<CommentDto> {
    return this.commentControllerToggleBlocked$Response(params, context).pipe(
      map((r: StrictHttpResponse<CommentDto>): CommentDto => r.body)
    );
  }

}
